import { Button } from "./ui/button";
import { Slider } from "./ui/slider";
import { Label } from "./ui/label";
import { _measuremntOptions } from "../../helper";

const colorPresets = [
  "#FFD700", // yellow
  "#FF0000", // teal
  "#00FF00", // amber
  "#FFFFFF", // brown
  // "#1E90FF", // violet
  "#FF00FF", // red
  // "#10B981", // orange
  "#FD652D", // gray
];

export function StylePanel({
  currentStyle,
  onStyleChange,
  onLineStyleChange,
  selectedLineStyle,
  onThinknessChange,
  selectedLineThikness,
}) {
  // Ensure defaults so the UI never crashes if something is missing
  const safe = {
    type: currentStyle?.type ?? "linear",
    unitColor: currentStyle?.unitColor ?? "#f59e0b",
    linear: {
      color: currentStyle?.linear?.color ?? "#3b82f6",
      thickness: currentStyle?.linear?.thickness ?? 2,
      dashStyle: currentStyle?.linear?.dashStyle ?? "solid",
    },
    angle: {
      color: currentStyle?.angle?.color ?? "#ef4444",
      thickness: currentStyle?.angle?.thickness ?? 2,
      dashStyle: currentStyle?.angle?.dashStyle ?? "solid",
    },
    polygon: {
      color: currentStyle?.polygon?.color ?? "#9333ea",
      thickness: currentStyle?.polygon?.thickness ?? 2,
      dashStyle: currentStyle?.polygon?.dashStyle ?? "solid",
    },
  };

  const currentType = safe.type; // "linear" | "angle" | "polygon"
  const activeStyle = safe[currentType]; // the slice we are editing
  // ——— handlers ———

  const handleColorChange = (color) => {
    // setSelectedColor(color)
    onStyleChange(color);
    // onStyleChange({
    //   ...safe,
    //   type: currentType,
    //   [currentType]: {
    //     ...activeStyle,
    //     color,
    //   },
    // });
  };

  const handleThicknessChange = (thicknessArr) => {
    const thickness = Array.isArray(thicknessArr)
      ? thicknessArr[0]
      : thicknessArr;
    onThinknessChange(thickness);
  };

  const handleDashStyleChange = (dashStyle) => {
    onLineStyleChange(dashStyle);
  };

  return (
    <div className="w-[97%] bg-[#F5F7FA] rounded-[8px] mt-2 -ms-2">
      <div className="px-2 py-1 space-y-4">
        {/* Header / Tool type */}
        <div className="flex items-start justify-between">
          <p className="text-[#000000] text-[14px] font-semibold p-0 m-0">
            Measurement Style
          </p>
        </div>

        {/* Thickness */}
        <div>
          <Label className="text-sm font-medium text-[#535353] block">
            Line Thickness: {selectedLineThikness}px
          </Label>
          <Slider
            value={[selectedLineThikness]}
            onValueChange={handleThicknessChange}
            min={1}
            max={10}
            step={1}
            className="w-full"
          />
        </div>

        {/* Line style */}
        <div>
          <Label className="text-sm font-medium text-[#535353] mb-2 block">
            Line Style
          </Label>
          <div className="flex gap-1 -ms-1">
            <Button
              variant={selectedLineStyle === "dotted" ? "default" : "outline"}
              size="sm"
              onClick={() => handleDashStyleChange("dotted")}
              className="flex-1 rounded-[8px] w-[50px] h-[30px] text-[10px]"
            >
              Dotted
            </Button>
            <Button
              variant={selectedLineStyle === "solid" ? "default" : "outline"}
              size="sm"
              onClick={() => handleDashStyleChange("solid")}
              className="flex-1 rounded-[8px] w-[50px] h-[30px] text-[10px]"
            >
              Solid
            </Button>
            <Button
              variant={selectedLineStyle === "dashed" ? "default" : "outline"}
              size="sm"
              onClick={() => handleDashStyleChange("dashed")}
              className="rounded-[8px] w-[50px] h-[30px] text-[10px]"
            >
              Dashed
            </Button>
          </div>
        </div>

        {/* Color presets */}
        <span className="text-sm font-medium text-[#535353] block">
          Line Color
        </span>
        <div className="grid grid-cols-6 gap-2 mb-2">
          {colorPresets.map((color) => (
            <button
              key={color}
              className={`w-7 h-7 rounded-[7px] border-2 transition-all border-gray-200 hover:border-gray-300`}
              style={{ backgroundColor: color }}
              onClick={() => handleColorChange(color)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
